import { OrderProgressEntity } from 'orders/domain/entities/order.entity'
import { OPERATION_MODE_CODES } from 'core/domain/operationModeConstants'

export interface ContainerlessRuleRow {
    key: string
    ruleName: string
    sequence: number | null
    chuteNumber: number | null
    packages: number
}

/**
 * Builds flat table rows for an order without containerization (SM-1118).
 *
 * - sorter: one row per chute (Chute · Regla · Paquetes), packages from the chute.
 * - classification: one row per rule (Regla · Paquetes), packages from the rule.
 *
 * Never includes container data.
 */
export class ContainerlessRuleAdapter {
    static buildRows(progress: OrderProgressEntity): ContainerlessRuleRow[] {
        const isSorter = progress.classificationType === OPERATION_MODE_CODES.SORTER
        if (!isSorter) {
            return progress.rules.map((rule, i): ContainerlessRuleRow => ({
                key: `${rule.ruleName}-${rule.sequence ?? i}`,
                ruleName: rule.ruleName,
                sequence: rule.sequence ?? null,
                chuteNumber: null,
                packages: rule.totalPackages,
            }))
        }

        return progress.rules.flatMap((rule, i): ContainerlessRuleRow[] => {
            const chutes = rule.chutes ?? []
            if (chutes.length === 0) {
                return [{
                    key: `${rule.ruleName}-${rule.sequence ?? i}`,
                    ruleName: rule.ruleName,
                    sequence: rule.sequence ?? null,
                    chuteNumber: null,
                    packages: rule.totalPackages,
                }]
            }
            return chutes.map((chute) => ({
                key: `${rule.ruleName}-${rule.sequence ?? i}-${chute.chuteNumber}`,
                ruleName: rule.ruleName,
                sequence: rule.sequence ?? null,
                chuteNumber: chute.chuteNumber,
                packages: chute.packageCount,
            }))
        })
    }
}
